// 需要传teamId的接口，将接口地址放入下面数组
import {
  LOGIN_LOGOUT,
  MEMBER_LIST_NEW,
  GET_BUY_PLAT_FORM,
  GET_PRODUCT_TYPE,
  GET_PRODUCT_SUB_TYPE,
  // SUPPORT_GET_BRAND,
  GET_CSS_PRODUCT_TYPE,
  // 短链管理
  GET_SHORT_LINK_LIST,
  // SHORT_LINK_SAVE,
  SHORT_LINK_DELETE,
  // SHORT_LINK_DETAIL,
  // 短信管理
  SMS_ACTIVITY_EVENTS,
  // SMS_DELETE_BY_ID,
  // GET_EVENT_DETAIL,
  // SMS_GET_ORG_MSG,
  // SMS_CONFIG,
  // SMS_TEST_SMS,
  // 消息中心
  MSG_CHANNEL_LIST,
  MSG_CENTER_CREATE,
  // 广告管理
  DD_VALUE_GET_AD_LIST,
  CMAD_GET_AD_DETAIL
} from './url';

let whiteConfig = [
  LOGIN_LOGOUT,
  MEMBER_LIST_NEW,
  GET_BUY_PLAT_FORM,
  GET_PRODUCT_TYPE,
  GET_PRODUCT_SUB_TYPE,
  // SUPPORT_GET_BRAND,
  GET_CSS_PRODUCT_TYPE,
  // 短链管理
  GET_SHORT_LINK_LIST,
  // SHORT_LINK_SAVE,
  SHORT_LINK_DELETE,
  // SHORT_LINK_DETAIL,
  // 短信管理
  SMS_ACTIVITY_EVENTS,
  // SMS_DELETE_BY_ID,
  // GET_EVENT_DETAIL,
  // SMS_GET_ORG_MSG,
  // SMS_CONFIG,
  // SMS_TEST_SMS,
  // 消息中心
  MSG_CHANNEL_LIST,
  MSG_CENTER_CREATE,
  // 广告管理
  DD_VALUE_GET_AD_LIST,
  CMAD_GET_AD_DETAIL
];
export default whiteConfig;
